module.exports = __webpack_public_path__ + "img/lifetime-logo.91d54a37.svg";